// @flow

import type {PermissionCodeType} from '../general/types';
import * as request from '../utils/request';
import {DOCUMENTS_API_URL, FOLDERS_API_URL} from '../urls';
import type {FolderType} from './types';

export const foldersFetcher = (params: {
  parent?: string,
  team_id?: number,
  document_url?: string,
  permission?: PermissionCodeType,
  search?: string,
}) => request.get(FOLDERS_API_URL, params);

export const createFolderFetcher = ({
  name,
  teamURLs,
  parent,
}: {|
  name: string,
  teamURLs: Array<string>,
  parent?: FolderType,
|}) =>
  request.postJson(FOLDERS_API_URL, {
    name,
    teams: teamURLs,
    parent: parent != null ? parent.url : undefined,
  });

export const createDocumentFetcher = ({
  document_content_type,
  object_id,
  folder,
}: {|
  document_content_type: 'procedure' | 'policy' | 'proceduregroup',
  object_id: number,
  folder: string,
|}) =>
  request.postJson(DOCUMENTS_API_URL, {
    folder,
    document_content_type,
    object_id,
  });
